import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, UserCog, Handshake, Newspaper, Images, Inbox, UserPlus, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  const cards = [
    { label: "Active Coaches", value: stats?.active_coaches, icon: Users, to: "/admin/coaches" },
    { label: "Active Staff", value: stats?.active_staff, icon: UserCog, to: "/admin/staff" },
    { label: "Active Sponsors", value: stats?.active_sponsors, icon: Handshake, to: "/admin/sponsors" },
    { label: "Published News", value: stats?.published_news, icon: Newspaper, to: "/admin/news" },
    { label: "Photo Albums", value: stats?.albums, icon: Images, to: "/admin/gallery" },
    { label: "New Contact Enquiries", value: stats?.new_contact, icon: Inbox, to: "/admin/enquiries", alert: true },
    { label: "New Joining Enquiries", value: stats?.new_joining, icon: UserPlus, to: "/admin/enquiries", alert: true },
    { label: "Pending Migration", value: stats?.pending_migration, icon: ShieldAlert, to: "/admin/migration", alert: true },
  ];

  return (
    <div>
      <h1 className="font-heading text-3xl font-extrabold uppercase text-white">Dashboard</h1>
      <p className="text-sm text-slate-400">Welcome to the BJRC club management portal.</p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="rounded-xl border border-slate-700 bg-[#151F30] p-5 transition-all hover:border-[#1E63D6]" data-testid={`stat-${c.label.toLowerCase().replace(/[^a-z]+/g,"-")}`}>
            <div className="flex items-center justify-between">
              <c.icon className={`h-6 w-6 ${c.alert && c.value > 0 ? "text-[#E8A317]" : "text-slate-500"}`} />
              {c.alert && c.value > 0 && <span className="rounded-full bg-[#E8A317] px-2 py-0.5 text-[10px] font-bold text-[#0A1626]">NEW</span>}
            </div>
            <div className="mt-3 font-mono text-3xl font-bold text-white">{c.value ?? "—"}</div>
            <div className="text-xs uppercase tracking-wide text-slate-400">{c.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
